export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '99吃瓜的“事件复盘”到底复的是什么？',
    a: '我们复盘的是一起互联网事件从萌芽、发酵到平息的全过程：谁先发声、关键信息如何传播、在哪个节点发生反转、各方如何回应、后续又有什么新进展。复盘的核心是还原前因后果，而不是替任何一方下结论。',
  },
  {
    q: '为什么同一件事会出现前后矛盾的说法？',
    a: '绝大多数“反转”源于信息在传播中被裁剪、错位或添油加醋。首发者往往只掌握片段，转发过程又会叠加情绪与二次加工。当更完整的事实或权威信源出现时，原先的叙事就可能被推翻。判断前，先分清哪些是事实、哪些是转述、哪些只是观点。',
  },
  {
    q: '遇到“实锤”截图和录音，我该怎么判断真假？',
    a: '先问三个问题：来源是否可核验？上下文是否完整？发布者是否有明显的立场或动机？断章取义、旧料重发和来路不明的“内部信源”都是最常见的失真来源。在缺少交叉验证前，把“实锤”当作“待核实线索”更稳妥。',
  },
  {
    q: '各方回应的声明长得都差不多，怎么看有没有诚意？',
    a: '建议把声明拆成“事实陈述”和“情绪表态”两部分。真正有信息量的回应会补充时间点、具体事实或后续动作，而不只是“深表遗憾、正在核实”。表态之后是否落地整改、是否追责，才是衡量诚意与后续进展的最终标尺。',
  },
  {
    q: '吃瓜会不小心违法吗？',
    a: '会。未经核实的事实性指控、对当事人的辱骂，以及恶意转发扩大不实信息传播，都可能触及名誉权甚至更严重的法律问题。匿名不代表免责，围观也请保留边界——用“据报道、待核实”这类限定词，能帮你显著降低误伤的风险。',
  },
  {
    q: '你们如何保证复盘是客观的？',
    a: '我们坚持“记录优先、结论延后”：先按时间线记录可溯源的事实，为关键信息标注信源，在缺乏新事实时允许结论悬置。同时会把各方的回应并列呈现，而不是只放单方面声音。每一篇复盘文末都欢迎读者用事实与我们讨论。',
  },
];

export interface BriefStat {
  label: string;
  value: string;
}

export const stats: BriefStat[] = [
  { label: '收录事件复盘', value: '1280+' },
  { label: '累计梳理信源', value: '3.6万+' },
  { label: '平均澄清时效', value: '约7小时' },
  { label: '常驻复盘编辑', value: '24人' },
];